/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminMarketplaceType,
    AdminMarketplaceTypeFromJSON,
    AdminMarketplaceTypeFromJSONTyped,
    AdminMarketplaceTypeToJSON,
} from './AdminMarketplaceType';

/**
 * 
 * @export
 * @interface AdminCreateProductMarketplace
 */
export interface AdminCreateProductMarketplace {
    /**
     * 
     * @type {string}
     * @memberof AdminCreateProductMarketplace
     */
    link: string;
    /**
     * 
     * @type {AdminMarketplaceType}
     * @memberof AdminCreateProductMarketplace
     */
    name: AdminMarketplaceType;
    /**
     * 
     * @type {number}
     * @memberof AdminCreateProductMarketplace
     */
    price: number;
}



export function AdminCreateProductMarketplaceFromJSON(json: any): AdminCreateProductMarketplace {
    return AdminCreateProductMarketplaceFromJSONTyped(json, false);
}

export function AdminCreateProductMarketplaceFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminCreateProductMarketplace {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'link': json['link'],
        'name': AdminMarketplaceTypeFromJSON(json['name']),
        'price': json['price'],
    };
}

export function AdminCreateProductMarketplaceToJSON(value?: AdminCreateProductMarketplace | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'link': value.link,
        'name': AdminMarketplaceTypeToJSON(value.name),
        'price': value.price,
    };
}

